/* eslint-disable standard/object-curly-even-spacing,import/no-duplicates,no-unused-vars,no-undef,no-multi-spaces,spaced-comment */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './lib/flexible.js' //阿里适配移动端库

import './initprototype'  // 原型方法
import './splitmint' // mint ui 样式
import './splitVant' // vant 样式
import './assets/styles/commom.less'  // 全局样式
import './assets/mint/mint_ui.less'  // 修改mint ui样式

import './utils/window_commom.js'  // 挂在window的方法
import './filters/index' //  过滤
import './directive/index.js'  //  自定义指令
import './utils/toast.js' // 提示框
import './assets/iconfont/zhwl_version_0.0_icon/iconfont.js' //  阿里巴巴图标库

import zhUi from '../ui/main.js'
import { Checklist , Swipe, SwipeItem} from 'mint-ui';//复选组件




Vue.component(Checklist.name, Checklist);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);

import '@/icons'

Vue.config.productionTip = false;

Vue.use(zhUi);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data() {
    return{
      _global_terminal:{
        clickVoice: 'clickVoice',
      }
    }
  },
  components: { App },
  template: '<App/>',

})






// WEBPACK FOOTER //
// ./src/main.js